import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import RadioButton from '../ui/radioButton';
import Text from '../ui/text';
import { url as productUrl } from '../../models/product';
import { previewVariant } from './actions';

class ProductVariants extends React.Component {
  select(variant) {
    const currentProduct = this.props.product;
    this.props.previewVariant(variant, currentProduct);
    const path = productUrl(variant);
    this.props.history.replace(path);
  }

  componentDidMount() {
    this._checkValidVariant();
  }

  componentDidUpdate() {
    this._checkValidVariant();
  }

  _checkValidVariant() {
    const currentProduct = this.props.product;
    const variants = currentProduct.volume_variants || [];
    const currentProductInVariants = variants.some(
      v => v.sku_id === currentProduct.sku_id
    );
    if (variants.length && !currentProductInVariants) {
      this.select(variants[0]);
    }
  }

  render() {
    const currentProduct = this.props.product;
    const variants =
      currentProduct.volume_variants ||
      (currentProduct.sku_id ? [currentProduct] : []);
    const sortedVariants = variants.sort((v1, v2) => v1.price - v2.price);
    const hasAddress = !!(this.props.address || this.props.zip);

    return (
      <div className="radio-list">
        {sortedVariants.map(product => (
          <ProductVariant
            product={product}
            hasAddress={hasAddress}
            checked={currentProduct.sku_id === product.sku_id}
            onChange={() => this.select(product)}
            key={currentProduct.sku_id + '-' + product.sku_id}
            selectedIngredients={this.props.selectedIngredients}
          />
        ))}
      </div>
    );
  }
}

function ProductVariant(props) {
  const product = props.product;

  const soldout = product.soldout;
  const hasPrice = !!product.price;
  const unavailable = props.hasAddress && !hasPrice;
  const freeShipping = product.free_shipping;
  const disabled = soldout || unavailable;

  const checked = props.checked;

  const itemClassName =
    'radio-list__option' +
    (disabled ? ' radio-list__option--disabled' : '') +
    (checked ? ' radio-list__option--checked' : '');
  const btnClassName =
    'radio-list__radio-btn' +
    (disabled ? ' radio-list__radio-btn--disabled' : '') +
    (checked ? ' radio-list__radio-btn--checked' : '');

  const selectedIngredients = props.selectedIngredients || [];
  const priceDisplay =
    checked && !!props.selectedIngredients.length
      ? selectedIngredients
          .reduce((sum, i) => {
            const product = i.selected || {};
            return (product.price || 0) + sum;
          }, 0)
          .toFixed(2)
      : product.priceDisplay;

  return (
    <RadioButton
      name="product-variant"
      id={`product-variant-${product.sku_id}`}
      onChange={disabled || checked ? () => {} : props.onChange}
      checked={checked}
      disabled={disabled}
      containerClass={itemClassName}
      btnClass={btnClassName}
      labelClass={disabled ? 'radio-button__label--with-subtitle' : ''}
    >
      <div className="radio-list__content">
        <div className="row middle-xs">
          <div className="col-xs-8">
            <div>{product.volume || product.volume_label}</div>
            {soldout && <div className="radio-list__subtitle">Sold Out</div>}
            {!soldout &&
              unavailable && (
                <div className="radio-list__subtitle">
                  Currently Unavailable
                </div>
              )}
            {!soldout &&
              !unavailable &&
              freeShipping && (
                <Text size="xs" error={!checked}>
                  Free Shipping
                </Text>
              )}
          </div>
          {hasPrice && (
            <div className="col-xs">
              <div className="radio-list__label">
                {!props.hasAddress ? (
                  <span>From</span>
                ) : (
                  !!product.regularPriceDisplay &&
                  product.regularPriceDisplay !== product.priceDisplay && (
                    <span className="text-light strikethrough">
                      ${product.regularPriceDisplay}
                    </span>
                  )
                )}
                <span> ${priceDisplay}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </RadioButton>
  );
}

export default withRouter(
  connect(
    state => ({
      address: state.address.address,
      zip: state.address.zip,
      selectedIngredients: state.product.selectedIngredients
    }),
    { previewVariant }
  )(ProductVariants)
);



// WEBPACK FOOTER //
// ./shared/components/product/variants.js